import { Box, Paper, Stack } from "@mui/material";
import { FC } from "react";
import { useShallow } from "zustand/shallow";
import { useCollectionDialogStore } from "./stores/CollectionDialogStore";
import { Header } from "./Header";
import { NameInput } from "./NameInput";
import { CollectionTypeSelect } from "../../../../components/CollectionTypeSelect/CollectionTypeSelect";
import { DescriptionInput } from "./DescriptionInput";
import { CompositeSelect } from "./CompositeSelect/CompositeSelect";
import { Actions } from "./Actions";
import { CollectionType } from "../../../../apis/bacchus/collections";

const COLLECTION_DIALOG_HEIGHT = "calc(100vh - 155px)";

export const CollectionDialog: FC = () => {
  const { isVisible, type, setType } = useCollectionDialogStore(
    useShallow((state) => ({
      isVisible: state.isVisible,
      type: state.type,
      setType: state.setType,
    }))
  );

  if (!isVisible) return null;

  return (
    <Box
      component={Paper}
      elevation={3}
      sx={{
        position: "fixed",
        right: "45px",
        bottom: "45px",
        width: 550,
        height: COLLECTION_DIALOG_HEIGHT,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        zIndex: 1,
        overflow: "hidden",
        boxShadow: 10,
        borderRadius: 2,
        border: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Header />

      <Stack padding="20px 20px" flex={1} gap={4} overflow="scroll">
        <NameInput />
        <DescriptionInput />
        <CollectionTypeSelect
          type={type}
          setType={(newType) => setType(newType as CollectionType)}
          dataTestId="collections-records-select"
        />
        <CompositeSelect />
      </Stack>

      <Actions />
    </Box>
  );
};
